import { Grid } from '@mui/material'
import { unwrapResult } from '@reduxjs/toolkit'
import React, { useEffect } from 'react'
import { Control, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import CONSTANTS, { PAGES_ROUTES, VALIDATIONS } from '../../../../Constants'
import { combineErrorMessage } from '../../../../Helpers/Util'
import { LanguagesListResponse } from '../../../../Models'
import { useAppDispatch, useAppSelector } from '../../../../Store/Hooks'
import { showAlert } from '../../../../Store/Slice/alert.slice'
import {
  createLanguageService,
  editLanguageService,
  selectLanguageData,
  setLanguagesData,
} from '../../../../Store/Slice/languages.slice'
import { MUIBox, MUIButton, MUIField, MUISelect } from '../../../Shared'
import styles from '../Masters.module.scss'

interface LanguagesCreateEditFormPropsInterface {
  mastersPageType: string | undefined
}
const LANGUAGE_CONTENTS = 'Language'
const status: any = [
  { value: 'ACTIVE', label: 'Active', type: 'status-active' },
  { value: 'INACTIVE', label: 'In Active', type: 'status-inactive' },
]

const LanguagesCreateEdit = ({ mastersPageType }: LanguagesCreateEditFormPropsInterface) => {
  const selectLanguage = useAppSelector(selectLanguageData)
  const selectedLanguageData: LanguagesListResponse | null =
    mastersPageType !== CONSTANTS.PAGE_TYPE.CREATE ? selectLanguage : null
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
  } = useForm<any>({
    defaultValues: {
      id: mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedLanguageData?._id : '',
      status:
        mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedLanguageData?.status : 'ACTIVE',
      value: mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedLanguageData?.value : '',
      key: mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedLanguageData?.key : '',
    },
  })

  useEffect(() => {
    // Update form values when selectedLanguageData changes
    setValue('id', mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedLanguageData?._id : '')
    setValue(
      'status',
      mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedLanguageData?.status : 'ACTIVE',
    )
    setValue(
      'value',
      mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedLanguageData?.value : '',
    )
    setValue('key', mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedLanguageData?.key : '')
  }, [selectedLanguageData, mastersPageType, setValue])

  const createLanguage = async (data: any) => {
    const reqData: any = {
      ...data,
    }
    const result = await dispatch(createLanguageService(reqData) as any)
    return result
  }

  const editLanguage = async (data: any) => {
    const reqData: any = {
      ...data,
    }
    const result = await dispatch(editLanguageService(reqData) as any)
    return result
  }

  const onSubmit = async (data: any) => {
    let result: any
    if (selectedLanguageData?._id && mastersPageType === CONSTANTS.PAGE_TYPE.EDIT) {
      result = await editLanguage(data)
    }
    if (mastersPageType === CONSTANTS.PAGE_TYPE.CREATE) {
      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        delete data?.id
      }
      result = await createLanguage(data)
    }
    const unWrapRes = unwrapResult(result)
    if (unWrapRes?.error) {
      dispatch(showAlert([true, combineErrorMessage(unWrapRes), 'error']))
      return
    }
    dispatch(showAlert([true, unWrapRes.message, 'success']))
    dispatch(setLanguagesData(null))
    navigate(`/${PAGES_ROUTES.MetaMaster}/${PAGES_ROUTES.Masters}/${PAGES_ROUTES.Languages}`)
  }

  return (
    <MUIBox>
      <div>
        <div className={`heading-6 d-flex text-left ${styles.masters__box__header__padding}`}>
          {LANGUAGE_CONTENTS}
        </div>
        <div className={styles.hr}></div>
        <div className={styles.mastersbox__content_padding}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container columnSpacing={10} rowSpacing={4}>
              <Grid item xs={6} md={6} lg={6} xl={6}>
                <MUIField
                  name='key'
                  label='Key'
                  required
                  type='text'
                  rules={{ required: VALIDATIONS.REQUIRED }}
                  control={control as Control | undefined}
                  error={errors}
                  maxLength={100}
                />
              </Grid>
              <Grid item xs={6} md={6} lg={6} xl={6}>
                <MUIField
                  name='value'
                  label='Value'
                  required
                  type='text'
                  rules={{ required: VALIDATIONS.REQUIRED }}
                  control={control as Control | undefined}
                  error={errors}
                  maxLength={100}
                />
              </Grid>
              <Grid item xs={6} md={6} lg={6} xl={6}>
                <MUISelect
                  name='status'
                  lable={'Status'}
                  required
                  rules={{ required: VALIDATIONS.REQUIRED }}
                  control={control as Control | undefined}
                  error={errors}
                  options={status}
                />
              </Grid>
              <Grid xs={12} item>
                <Grid container spacing={10}>
                  <Grid item xs={6}></Grid>

                  <Grid item xs={6} className='d-flex justify-content-end'>
                    <MUIButton
                      disabled={!isValid}
                      size='large'
                      type={'submit'}
                      label={'Submit'}
                      variant='contained'
                      width={200}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {/* <div className={styles.submit__handler}>
              <div className={styles.submit__handler_btn_cont}>
                <MUIButton
                  size='large'
                  type={'submit'}
                  label={'Submit'}
                  variant='contained'
                  width={200}
                />
              </div>
            </div> */}
          </form>
        </div>
      </div>
    </MUIBox>
  )
}

export default React.memo(LanguagesCreateEdit)
